module.exports = __webpack_public_path__ + "img/house.8ac1ed12.svg";